import { Grid2 as Grid } from "@mui/material";
import { hasModifyAccessToResource } from "api/general";
import { Subheader } from "components/Header/Subheader/Subheader";
import { Item, OLTabs } from "components/Tabs/OLTabs";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import { useEffect } from "react";

export enum Tab {
  WALLET = "wallets",
  CUSTOM_EVENT = "customEvents",
  REWARDS = "rewards",
  ACHIEVEMENTS = "achievements",
  CAMPAIGNS = "campaigns",
  REFERRALS = "referrals",
  AUTOMATIONS = "automations",
}

interface Props {
  activeTab?: Tab;
  setActiveTab: (tab: Tab) => void;
  selectedCount: number;
  fetchResourcesData: () => void;
}

export const Tabs = ({
  activeTab,
  setActiveTab,
  selectedCount,
  fetchResourcesData,
}: Props) => {
  const { message } = useMessage();
  const hasModifyCampaignPermission = hasModifyAccessToResource("CAMPAIGN");
  const hasModifyCustomEventPermission =
    hasModifyAccessToResource("CUSTOM_EVENT");
  const hasModifyWalletPermission = hasModifyAccessToResource("WALLET");
  const hasModifyRewardsPermission = hasModifyAccessToResource("REWARDS");

  const tabs: Item[] = [
    ...(hasModifyWalletPermission
      ? [{ id: Tab.WALLET, name: message({ id: "wallets" }) }]
      : []),
    ...(hasModifyCustomEventPermission
      ? [{ id: Tab.CUSTOM_EVENT, name: message({ id: "customEventSchemas" }) }]
      : []),
    ...(hasModifyRewardsPermission
      ? [{ id: Tab.REWARDS, name: message({ id: "rewards" }) }]
      : []),
    ...(hasModifyCampaignPermission
      ? [
          { id: Tab.ACHIEVEMENTS, name: message({ id: "achievements" }) },
          { id: Tab.CAMPAIGNS, name: message({ id: "campaigns" }) },
          { id: Tab.REFERRALS, name: message({ id: "referrals" }) },
          { id: Tab.AUTOMATIONS, name: message({ id: "automations" }) },
        ]
      : []),
  ];

  useEffect(() => {
    if (!activeTab) {
      setActiveTab(tabs[0].id as Tab);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Subheader>
      <Grid size={{ xs: 8 }}>
        <OLTabs
          items={tabs}
          value={activeTab || false}
          onChange={(_e, tab: Tab) => setActiveTab(tab)}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <OLButton
          variant="contained"
          onClick={fetchResourcesData}
          disabled={selectedCount < 1}
        >
          {message(
            { id: "duplicateSelectedRecords" },
            { count: selectedCount },
          )}
        </OLButton>
      </Grid>
    </Subheader>
  );
};
